import { create } from "zustand"
import { persist } from "zustand/middleware"
import {
  hexToRgba,
  getTextColorForBackground,
  darkenColor,
} from "toptaal-shared"

interface OrganizationColorsStore {
  primaryColor: string
  secondaryColor: string
  setColors: (primaryColor: string, secondaryColor: string) => void
}

function applyColors(primaryColor: string, secondaryColor: string) {
  const root = document.documentElement
  const primaryTextColor = getTextColorForBackground(primaryColor)

  root.style.setProperty("--color-primary-green", hexToRgba(primaryColor, 1))
  root.style.setProperty(
    "--color-primary-dark-green",
    darkenColor(primaryColor, 0.15),
  )
  root.style.setProperty(
    "--color-primary-medium-blue",
    hexToRgba(secondaryColor, 0.5),
  )
  root.style.setProperty(
    "--color-primary-light-blue",
    hexToRgba(secondaryColor, 0.15),
  )
  root.style.setProperty(
    "--color-primary-text-on-bg",
    primaryTextColor === "white" ? "#FFFFFF" : "#000000",
  )
}

export const useOrganizationColorsStore = create<OrganizationColorsStore>()(
  persist(
    (set) => ({
      primaryColor: "#009060",
      secondaryColor: "#64CAF0",
      setColors: (primaryColor: string, secondaryColor: string) => {
        set({ primaryColor, secondaryColor })
        requestAnimationFrame(() => {
          applyColors(primaryColor, secondaryColor)
        })
      },
    }),
    {
      name: "organization-colors",
      onRehydrateStorage: () => (state) => {
        if (state && typeof window !== "undefined") {
          applyColors(state.primaryColor, state.secondaryColor)
        }
      },
    },
  ),
)
